/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRequestAppointmentModal_item$ref = any;
export type PdpRequestAppointmentModalLoader_item$ref = any;
export type PdpRequestAppointmentModalLoader_item = {
    readonly " $fragmentRefs": PdpRequestAppointmentModal_item$ref;
    readonly " $refType": PdpRequestAppointmentModalLoader_item$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRequestAppointmentModalLoader_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRequestAppointmentModal_item",
      "args": null
    }
  ]
};
(node as any).hash = '84aea6f3784648ec8b97d2c79cbb0dab';
export default node;
